<template>
    <div>
        <vx-Card title="Ativos" refresh-content-action collapse-action :close="false" @refresh="refreshChart('ativos')" @download="downloadData('ativos')" :download-card-action="cards.ativos.showDownload">
            <ativos ref="ativos" :salers="salers" :companies="companies" @showDownload="(show) => showDownloadButton('ativos', show)"></ativos>
        </vx-Card>
        <vx-Card title="Inadimplentes" refresh-content-action collapse-action :close="true" @refresh="refreshChart('inadimplentes')" @download="downloadData('inadimplentes')" :download-card-action="cards.inadimplentes.showDownload">
            <inadimplentes ref="inadimplentes" :salers="salers" :companies="companies" @showDownload="(show) => showDownloadButton('inadimplentes', show)"></inadimplentes>
        </vx-Card>
        <vx-Card title="Inativos" refresh-content-action collapse-action :close="true" @refresh="refreshChart('inativos')" @download="downloadData('inativos')" :download-card-action="cards.inativos.showDownload">
            <inativos ref="inativos" :salers="salers" :companies="companies" @showDownload="(show) => showDownloadButton('inativos', show)"></inativos>
        </vx-Card>
        <vx-Card title="Clientes Por Segmentos" refresh-content-action collapse-action :close="true" @refresh="refreshChart('segmento')" @download="downloadData('segmento')" :download-card-action="cards.segmento.showDownload">
            <segmento ref="segmento" :salers="salers" :companies="companies" :activities="activities" @showDownload="(show) => showDownloadButton('segmento', show)"></segmento>
        </vx-Card>
        <vx-Card title="Clientes Por Estados" refresh-content-action collapse-action :close="true" @download="downloadData('clientesPorEstado')" :download-card-action="cards.clientesPorEstado.showDownload">
            <regiao ref="clientesPorEstado" @showDownload="(show) => showDownloadButton('clientesPorEstado', show)"></regiao>
        </vx-Card>
    </div>
</template>

<script>
    import { revendaApi } from "@/api/axios";
    export default {
        components:{
            ativos: () => import("./Clientes/Ativos"),
            inativos: () => import("./Clientes/Inativos"),
            inadimplentes: () => import("./Clientes/Inadimplentes"),
            segmento: () => import("./Clientes/Segmento"),
            regiao: () => import("./Clientes/Regiao"),
        },
        data()
        {
            return {
                companies: [],
                salers: [],
                activities: [],
                cards: {

                    ativos: {
                        showDownload: false
                    },
                    inadimplentes: {
                        showDownload: false
                    },
                    inativos: {
                        showDownload: false

                    },
                    segmento: {
                        showDownload: false
                    },
                    clientesPorEstado: {
                        showDownload: false
                    },
                }
            }
        },
        methods: {
            showDownloadButton(table, show)
            {
                this.cards[table].showDownload = show
            },
            downloadData(report)
            {
                this.$refs[report].downloadTable()
            },
            refreshChart(chart)
            {
                this.$refs[chart].loadChart()
            },

            async getSalers() {
                const {data} = await revendaApi.get('saler/all')
                this.salers = data.map(vendedor => {return {label:vendedor.nome, value:vendedor.id_pessoa}})
            },

            async getCompanies() {
                const {data} = await revendaApi.get('company/all')
                this.companies = data.map(item => {return {label:item.nome, value:item.id_pessoa}})
            },

            async getActivities() {
                const {data} = await this.$axios.get(`consulta/bussiness`)
                if(data){
                    this.activities = data.map(atividades => {return {label: atividades.nome, value: atividades.id_atividade_empresa}})
                }
            },

            async getQuantityData () {
                const {data} = await revendaApi.get('stats/companies/states')
                return data
            },

            formatDataTableCompaniesByStates(data)
            {
                const states = new Set(data.flatMap(row => row.estado))
                const values = []

                states.forEach(state => {
                    const row = {}
                    this.statsPeriod.forEach(period => {
                        row[period] = 0
                    })
                    const periods = data.filter(period => period.estado === state).forEach(period => {
                        const periodInfo = period.periodo.split('-')
                        row[`${this.months[periodInfo[1] - 1]} ${periodInfo[0]}`] = period.total
                    })
                    row.estado = state
                    values.push(row)
                })

                this.quantityData = values
            },

        },

        mounted() {
            this.getSalers()
            this.getCompanies()
            this.getActivities()
        },
    }
</script>
